import React from 'react'
import Image from './Image'
// import { Link } from 'gatsby-plugin-modal-routing'
import ReactModal from 'react-modal'

import video from "../assets/videos/bankinvoice.mp4"



class VideoImage extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isModalOpen: false
        }
        this.onMovieImageClick = this.onMovieImageClick.bind(this)
        this.handleModalClose = this.handleModalClose.bind(this)
    }

    onMovieImageClick(e) {
        console.log(e)
        this.setState({ isModalOpen: true })

    }

    handleModalClose = () => {
        // console.log('handleModalOpen: ', event);
        this.setState({ isModalOpen: false })
    }


    render() {
        return (
            <div id="video">
            <div className="container bankinvoice-movie-image"
            onClick={ this.onMovieImageClick }
            >
                <Image filename="movie-fake.png" alt="movie-fake" />
            </div>
            <ReactModal
            className="videoModal"
            overlayClassName="overLay"
            isOpen={this.state.isModalOpen}
            onRequestClose={this.handleModalClose}
            >
            <video controls>
                <source src={video} type="video/mp4" />
            </video>
            </ReactModal>
            </div>
        )
    }
}

export default VideoImage
